import React from "react";
import { Table, Pagination, CardGroup, Card } from 'react-bootstrap';

const Review = () => {
    return (

        <div className="review">
            <h1>베스트 리뷰</h1>
            <CardGroup>
                <Card>
                    <Card.Img variant="top" src={process.env.PUBLIC_URL + "/img/review1.JPG"}  />
                    <Card.Body>
                        <Card.Title>★★★★★</Card.Title>
                        <Card.Text>
                            요즘 날씨에 입기 부담없고 화사해서 이뻐요~
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer>
                        <small className="text-muted">2023-03-10</small>
                        <small className="text-muted">june</small>
                    </Card.Footer>
                </Card>
                <Card>
                    <Card.Img variant="top" src={process.env.PUBLIC_URL + "/img/review2.JPG"} />
                    <Card.Body>
                        <Card.Title>★★★★★</Card.Title>
                        <Card.Text>
                            원단도 좋고 운동할 때 입으면 가벼워서 자주 찾게되는 옷이에요!
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer>
                        <small className="text-muted">2023-03-01</small>
                        <small className="text-muted">sara</small>
                    </Card.Footer>
                </Card>
                <Card>
                    <Card.Img variant="top" src={process.env.PUBLIC_URL + "/img/review3.JPG"} />
                    <Card.Body>
                        <Card.Title>★★★★★</Card.Title>
                        <Card.Text>
                        신상품이라 후기가 없어서 고민했는데 질감도 좋고 너무 맘에 들어요
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer>
                        <small className="text-muted">2023-03-01</small>
                        <small className="text-muted">tomy</small>
                    </Card.Footer>
                </Card>
            </CardGroup>
            <Table striped>
                <tbody>
                    <tr>
                        <td className="star">★★★★★</td>
                        <td>생각보다 사이즈가 크지만 이쁩니다!</td>
                        <td>mary</td>
                        <td>2023-03-15</td>
                    </tr>
                    <tr>
                        <td className="star">★★★★★</td>
                        <td>배송 오래 기다렸는데 화면보다 실물이 훨씬 이뻐요~ 만족합니다.</td>
                        <td>jake</td>
                        <td>2023-03-13</td>
                    </tr>
                    <tr>
                        <td className="star">★★☆☆☆</td>
                        <td>사이즈가 잘못 왔어요</td>
                        <td>harry</td>
                        <td>2023-03-13</td>
                    </tr>
                    <tr>
                        <td className="star">★★★☆☆</td>
                        <td>색상이 생각한거랑 달라요</td>
                        <td>tom</td>
                        <td>2023-03-12</td>
                    </tr>
                    <tr>
                        <td className="star">★★★★★</td>
                        <td>친구 생일 선물로 샀는데 마음에 엄청 들어했어요~</td>
                        <td>john</td>
                        <td>2023-03-11</td>
                    </tr>
                </tbody>
            </Table>

            <Pagination>
                <Pagination.First />
                <Pagination.Prev />
                <Pagination.Item active>{1}</Pagination.Item>
                <Pagination.Item>{2}</Pagination.Item>
                <Pagination.Item>{3}</Pagination.Item>
                <Pagination.Item>{4}</Pagination.Item>
                <Pagination.Item>{5}</Pagination.Item>
                <Pagination.Next />
                <Pagination.Last />
            </Pagination>
        </div>
    )
}

export default Review;